import { render, staticRenderFns } from "./WorkerPositionForm.vue?vue&type=template&id=082b3a2a"
import script from "./WorkerPositionForm.vue?vue&type=script&lang=js"
export * from "./WorkerPositionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports